<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="downloads">
    <h1 class="font-weight-thin display-1 grey--text ml-3 mt-3 hidden-xs-only">
      Downloads & Keys
    </h1>
    <div class="ml-3 my-3 mr-3">
      <div class="pa-2 rounded-card" style="background-color: white;">
        <v-toolbar flat color="white">
          <v-toolbar-title class="mt-3">
            <span class="primary--text text-lighten-2"
              >Groupmail Client Downloads
            </span>
          </v-toolbar-title>
        </v-toolbar>
        <div class="ml-4 grey--text">
          To use Groupmail you'll need to download the latest client software
          for your computer. Click on the download link for the version you want
          below and open it once it has downloaded to begin the installation
          process.
        </div>
        <div
          class="ml-4 mt-4 subheading grey--text"
          v-if="downloads.length === 0"
        >
          * No downloads available at this time
          <span v-if="error">({{ errorMessage }})</span>
        </div>
        <v-card
          class="ma-2"
          flat
          v-for="download in downloads"
          :key="download._id"
        >
          <v-layout row wrap class="pa-3">
            <v-flex xs12 md4>
              <div class="caption grey--text">Operating System</div>
              <div>{{ download.os }}</div>
            </v-flex>
            <v-flex xs3 md1>
              <div class="caption grey--text">Version</div>
              <div>
                {{ download.version }} &nbsp;
                <v-tooltip bottom v-if="download.changeLog">
                  <template v-slot:activator="{ on }">
                    <v-icon small color="info" v-on="on">info</v-icon>
                  </template>
                  <span>{{ download.changeLog }}</span>
                </v-tooltip>
              </div>
            </v-flex>
            <v-flex xs3 md1>
              <div class="caption grey--text">Size</div>
              <div>{{ download.size }}</div>
            </v-flex>
            <v-flex xs4 md2>
              <div class="caption grey--text">Released</div>
              <div>{{ shortDate(download.release) }}</div>
            </v-flex>
            <v-flex xs12 md3>
              <div>
                <v-btn
                  v-if="download.url"
                  small
                  :outline="!platformIs(download.os)"
                  depressed
                  round
                  :color="platformIs(download.os) ? 'success' : 'info'"
                  @click="downloadFile(download.url)"
                  >Download</v-btn
                >
                <v-btn
                  v-if="download.tutorial"
                  small
                  flat
                  color="info"
                  :href="download.tutorial"
                  target="_blank"
                  >Install Guide</v-btn
                >
              </div>
            </v-flex>
            <v-flex xs12 class="hidden-xs-only">
              <div class="grey--text">{{ download.description }}</div>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
    </div>
    <div class="ml-3 my-3 mr-3">
      <div class="pa-2 rounded-card" style="background-color: white;">
        <v-toolbar flat color="white">
          <v-toolbar-title class="mt-3">
            <span class="primary--text text-lighten-2"
              >Groupmail API Keys
            </span>
          </v-toolbar-title>
        </v-toolbar>
        <div class="ml-4 grey--text">
          To use Groupmail with third party services like Zapier you'll need to
          use these details:
        </div>
        <v-card class="ma-2" flat>
          <v-layout row wrap class="pa-3">
            <v-flex class="ml-4" xs12 md6>
              <div>
                <v-text-field
                  v-model="teamId"
                  label="Team ID"
                  ref="teamId"
                  readonly
                  append-icon="file_copy"
                  @click:append="copyTeamId"
                />
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="pa-3">
            <v-flex class="ml-4" xs12 md6>
              <v-text-field
                v-model="apiKey"
                label="API Key"
                ref="apiKey"
                readonly
                append-icon="file_copy"
                @click:append="copyApiKey"
              />
            </v-flex>
          </v-layout>
        </v-card>
        <div class="ml-4 grey--text">
          Please refer to the Groupmail Terms and Conditions regarding usage of
          these keys.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(utc);
dayjs.extend(LocalizedFormat);

export default {
  // getDownloads from vuex/accounts actions return array of available downloads
  name: 'Download',
  data: function() {
    return {
      downloads: [],
      teamId: null,
      apiKey: null,
      error: false,
      errorMessage: true
    };
  },
  created: async function() {
    this.error = false;
    this.downloads = await this.$store.dispatch('account/getDownloads');
    this.teamId = this.$store.state.auth.team._id;
    this.apiKey = this.$store.state.auth.apiKey;
    if (!Array.isArray(this.downloads)) {
      if (this.downloads.error) {
        this.error = true;
        this.errorMessage = this.downloads.message;
      }
      this.downloads = [];
    }
  },
  methods: {
    copyTeamId() {
      const textToCopy = this.$refs.teamId.$el.querySelector('input');
      textToCopy.select();
      document.execCommand('copy');
    },
    copyApiKey() {
      const textToCopy = this.$refs.apiKey.$el.querySelector('input');
      textToCopy.select();
      document.execCommand('copy');
    },
    shortDate(dateString) {
      return dayjs.utc(dateString).format('ll');
    },
    downloadFile(url) {
      if (url) {
        window.open(url);
      }
    },
    platformIs(type) {
      const typeTolower = type.toLowerCase();
      let platform = 'unknown';
      if (navigator.appVersion.indexOf('Win') !== -1) platform = 'windows';
      if (navigator.appVersion.indexOf('Mac') !== -1) platform = 'macos';
      // if (navigator.appVersion.indexOf('X11') !== -1) platform = 'unix';
      // if (navigator.appVersion.indexOf('Linux') !== -1) platform = 'linux';
      if (typeTolower === platform) {
        return true;
      }
    }
  }
};
</script>
<style>
.rounded-card {
  border-radius: 10px;
}
</style>
